// React
import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Containers Injections
import { OrganizationsInjection } from '../../containers/organizationsInjection';

// View
import { OrganizationsListPage } from './view';

export const OrganizationsList = () => {
  const [activeStatus, setActiveStatus] = useState('true');

  const history = useHistory();

  const { success, organizations, getOrganizations, deleteOrganizations } =
    OrganizationsInjection();

  const handleDelete = (id) => {
    deleteOrganizations(id);
  };

  const handleEdit = (values) => {
    const { hashid } = values;

    history.push(`/organizacoes/edit/${hashid}`);
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Nome</span>,
      sortable: true,
      width: '30%',
      cell: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <Link
                className="currency_name"
                to={`/organizacoes/edit/${cell.hashid}`}
              >
                {cell.name}
              </Link>
            </div>
          </React.Fragment>
        );
      },
      selector: (cell) => cell.name,
    },
    {
      name: <span className="font-weight-bold fs-13">CNPJ</span>,
      sortable: true,
      width: '20%',
      selector: (cell) => cell.cnpj || '-',
    },
    {
      name: <span className="font-weight-bold fs-13">Categoria</span>,
      sortable: true,
      width: '20%',
      selector: (cell) => cell.category_name,
    },
    {
      name: <span className="font-weight-bold fs-13">Cidade</span>,
      sortable: true,
      width: '20%',
      selector: (cell) => cell.city_name || '-',
    },
  ];

  useEffect(() => {
    getOrganizations(activeStatus);
  }, [success, activeStatus]);

  return (
    <OrganizationsListPage
      // data
      organizations={organizations || []}
      // utils
      columns={columns}
      history={history}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      setActiveStatus={setActiveStatus}
    />
  );
};
